import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getFormMode } from "../../../../lib/helpers";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import { z } from "zod";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import {
  insertModuleRights,
  moduleRightsDrp,
  retriveModuleRights,
  updateModuleRights,
} from "../../../../Api/ModuleRights/Api";


const FORM_MODE = getFormMode();

const FORM_INIT_STATE = {
  ParentId: "",
  ModuleName: "",
  ModuleDesc: "",
  ModuleRoutig: "",
 ModuleTblName: "",
};

const moduleFormSchema = z.object({
  ParentId: z.number().min(1, "ParentMenu is required"),
  ModuleName: z.string().min(1, "Menu Name is required"),
  ModuleDesc: z.string().optional(),
  ModuleRoutig: z.string().optional(),
 ModuleTblName: z.string().optional(),
});

const ModuleRights = () => {
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState(FORM_INIT_STATE);
  const [currentModuleId, setCurrentModuleId] = useState(() => {
    return location?.state?.ModuleId;
  });
  const [mode, setMode] = useState(() =>
    currentModuleId ? FORM_MODE.read : FORM_MODE.add
  );
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [modules, setModules] = useState([]);
  const [Status, setStatus] = useState("1");

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };


  useEffect(() => {
      (async () => {
        const response = await moduleRightsDrp();
        if (response instanceof Error) {
          return console.error(response.message, "could not fetch module");
        }
        const {
         data: {Status,Data}
        } = response;
        if (Status === 0 && Array.isArray(Data)) {
          setModules(Data);
        } else {
          return console.error("Error: Promocode not found");
        }
      })();
    }, []);

  //For Retrive
  useEffect(() => {
    if (currentModuleId) {
      fetchModuleData();
    }
  }, []);

  const handlePrevious = async () => {
    if (!currentModuleId && currentModuleId < 1) return;
    await fetchModuleData("P");
  };

  const handleNext = async () => {
    if (!currentModuleId) return;
    await fetchModuleData("N");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
    }
  };

  const handleEdit = async () => {
    setMode(FORM_MODE.edit);
  };

  const handleAdd = () => {
    setMode(FORM_MODE.add);
    setForm(FORM_INIT_STATE);
  };

  const handleCancel = async (flag = "L") => {
    if (mode === FORM_MODE.add) {
      await fetchModuleData("L", 1);
    } else {
      await fetchModuleData("R");
    }
    setMode(FORM_MODE.read);
  };

  const handleExit = () => {
    navigate(`/module-rights-table`);
  };

  const handleDelete = async () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      await fetchModuleData("D");
      const response = await retriveModuleRights({
        ModuleId: currentModuleId,
        Flag: "D",
      });
      if (response instanceof Error) {
        return console.error("Error: could not delete room");
      }
      const {
        data: { Status, Message, Data },
      } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 1000 });
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 1000 });
        } else {
          toast.error(Message, { autoClose: 1000 });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchModuleData = async (flag = "R", ModuleId = 1) => {
    const response = await retriveModuleRights({
      ModuleId: currentModuleId ?? ModuleId,
      Flag: flag,
    });
    if (response instanceof Error) {
      return console.log(response.message);
    }
    const {
      data: { Status, responseStatusCode, Data, Message },
    } = response;
    if (
      Status === 0 &&
      responseStatusCode === 1 &&
      Data &&
      Array.isArray(Data)
    ) {
      const data = Data[0];
      setForm({
        ParentId: data.ParentId,
        ModuleName: data.ModuleName,
        ModuleDesc: data.ModuleDesc,
        ModuleRoutig: data.ModuleRoutig,
       ModuleTblName: data.ModuleTblName,
      });
      setStatus(data.Status?.toString() || "0");
      setMode(FORM_MODE.read);
      setCurrentModuleId(data.ModuleId);
    } else {
      console.log(Message);
    }
  };
  
  const handleSubmit = async () => {
    const result = moduleFormSchema.safeParse(form);

    if (!result.success) {
      return toast.info("Please fill in all required inputs correctly.", {
        autoClose: 1000,
      });
    }
    const { data } = result;
    const payload = {
      ParentId: data.ParentId,
      ModuleName: data.ModuleName,
      ModuleDesc: data.ModuleDesc,
      ModuleRoutig: data.ModuleRoutig,
     ModuleTblName: data.ModuleTblName,
      Status: "1",
    };

    let response;
    if (mode === FORM_MODE.edit && currentModuleId) {
      payload.ModuleId = currentModuleId;
      payload.UpdatedBy = UserId;

      response = await updateModuleRights(payload);
    } else {
      payload.CreatedBy = UserId;
      response = await insertModuleRights(payload);
    }

    if (response instanceof Error) {
      console.error("Error:Could not submit form");
    }
    const {
      data: { Status, Message },
    } = response;
    if (Status === 0) {
      setMode(FORM_MODE.read);
      toast.success(Message, {
        autoClose: 1000,
      });
    } else {
      console.error(Message);
    }
  };

  return (
    <>
      <ToastContainer />
      <Box className="form-container">
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Grid>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#635bff" }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== FORM_MODE.read ||
                  !currentModuleId ||
                  currentModuleId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== FORM_MODE.read}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <h3>Module Master</h3>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#635bff" }}
                onClick={handleAdd}
                disabled={mode !== FORM_MODE.read}
              >
                <AddIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
                onClick={handleEdit}
                disabled={mode !== FORM_MODE.read}
              >
                <EditIcon />
              </Button>
              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#635bff" }}
                onClick={handleDelete}
                disabled={mode !== FORM_MODE.read || mode === FORM_MODE.add}
              >
                <DeleteIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: "#635bff", margin: "0px 10px" }}
                onClick={handleExit}
                disabled={mode !== FORM_MODE.read}
              >
                <CancelPresentationIcon />
              </Button>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            className="form_field"
            sx={{ marginInline: "50px" }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <FormControl
                      variant="filled"
                      fullWidth
                      className="custom-select"
                    >
                      <InputLabel id="authority-select-label">
                        Menu <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="authority-select-label"
                        id="authority-select"
                        name="ParentId"
                        value={form.ParentId}
                        onChange={handleInputChange}
                        className="custom-textfield"
                        disabled={mode === FORM_MODE.read}
                      >
                        {modules.map((module) => (
                          <MenuItem key={module.Id} value={module.Id}>
                            {module.Name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="modulename"
                      name="ModuleName"
                      label={
                        <span>
                          Menu Name
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.ModuleName}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="moduleroutig"
                      name="ModuleRoutig"
                      label={
                        <span>
                          Routing
                        
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.ModuleRoutig}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="ModuleTblName"
                      name="ModuleTblName"
                      label={
                        <span>
                          Table Name
                        </span>
                      }
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.ModuleTblName}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      id="moduledesc"
                      name="ModuleDesc"
                      label="Description"
                      variant="filled"
                      fullWidth
                      className="custom-textfield"
                      value={form.ModuleDesc}
                      onChange={handleInputChange}
                      disabled={mode === FORM_MODE.read}
                    />
                  </Grid>

                  <Grid item xs={12} md={2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled
                            checked={Status === "1"}
                            onChange={handleChangeStatus}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === FORM_MODE.read && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === FORM_MODE.edit || mode === FORM_MODE.add) && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModuleRights;
